import React from 'react';
import { Header } from '../../utils/Login/Header';
import { Footer } from '../../utils/Login/Footer';
import './Login.css'

export const LayoutLogin = ({ version, children }) => (
  <>
  <div className='body-grid'>
    <Header />
      <main className='site-content'>
        {children}
      </main>
      <Footer version={ version } />
  </div>
  </>
);